import { createAction } from '@ngrx/store';

export const logout = createAction('[Auth Manager] Logout');
export const logoutEverywhere = createAction('[Auth Manager] Logout Everywhere');
export const logoutFinished = createAction('[Auth Manager] Logout Finished');